export enum WebsitePageTypesEnum {
  WebsiteLayout = 'website_layout',
  WebsiteHomepage = 'website_homepage',
}
